import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Attach JWT token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const loginUser = (data) => API.post('/auth/login', data);
export const registerUser = (data) => API.post('/auth/register', data);
export const getMe = (token) => API.get('/auth/me', token ? { headers: { Authorization: `Bearer ${token}` } } : {});

export const getSettings = () => API.get('/settings');
export const saveSettings = (data) => API.post('/settings', data);
export const checkApiKey = (apiKey, signal) => API.post('/settings/check-api-key', { apiKey }, { signal, timeout: 18000 });
export const uploadStyleImage = (imageBase64) => API.post('/settings/style-image', { imageBase64 });
export const hasStyleImage = () => API.get('/settings/has-style-image');
export const getStyleImages = () => API.get('/settings/style-images');
export const setDefaultStyleImage = (fileName) => API.post('/settings/style-images/set-default', { fileName });
export const deleteStyleImage = (fileName) => API.delete(`/settings/style-images/${fileName}`);
export const getStyleImageUrl = (fileName) => `/api/settings/style-images/${fileName}`;
export const generate = (sourceImageBase64, colorChanges = {}) =>
  API.post('/generate', {
    sourceImageBase64,
    mainColorChange: colorChanges.mainColorChange || null,
    topColorChange: colorChanges.topColorChange || null,
    bottomColorChange: colorChanges.bottomColorChange || null,
  });
export const dressGenerate = (selections) =>
  API.post('/generate/dress', selections);
export const getHistory = () => API.get('/generate/history');
export const getLiked = () => API.get('/generate/liked');
export const getExplorer = () => API.get('/generate/explorer');
export const toggleLike = (id) => API.post(`/generate/${id}/like`);
export const incrementView = (id) => API.post(`/generate/${id}/view`);
export const deleteDesign = (id) => API.delete(`/generate/${id}`);
export const setVisibility = (id, visibility) => API.put(`/generate/${id}/visibility`, { visibility });
export const getUserProfile = () => API.get('/generate/profile');
export const getGeneratedImageUrl = (fileName) => `/api/generate/image/${fileName}`;

// Field Options
export const getFieldOptions = () => API.get('/field-options');
export const addFieldOption = (data) => API.post('/field-options', data);
export const updateFieldOption = (id, data) => API.put(`/field-options/${id}`, data);
export const deleteFieldOption = (id) => API.delete(`/field-options/${id}`);

// Admin - User Management
export const getAdminUsers = () => API.get('/admin/users');
export const addUserCredits = (id, amount) => API.put(`/admin/users/${id}/credits`, { amount });
export const updateUserSubscription = (id, subscriptionStatus) => API.put(`/admin/users/${id}/subscription`, { subscriptionStatus });
export const updateUserRole = (id, role) => API.put(`/admin/users/${id}/role`, { role });
export const toggleUserSuspend = (id) => API.put(`/admin/users/${id}/suspend`);
export const deleteUser = (id) => API.delete(`/admin/users/${id}`);
